import { format, parseISO } from 'date-fns'
import React, { useRef } from 'react'
import { ProjectItemMenu } from '@chegg-wt/core/components/ProjectItemMenu'
import { NOOP } from '@chegg-wt/core/constants/global'
import AppLink from '../AppLink'
import { HiddenLabel } from '../HiddenLabel'
import VisibleOnHoverWrapper from '../VisibleOnHoverWrapper'
import { PROJECT_ITEM } from './testIds'
import {
  ListItemLink,
  ListItemLinkWithMenu,
  ListItemDateText,
  ListItemName,
  ProjectListItem,
} from './styled'
import { BaseProjectListItemProps } from './types'

export const BaseProjectListItem: React.FunctionComponent<BaseProjectListItemProps> = ({
  index,
  name,
  date,
  onClick,
  hideActionMenu,
  onDelete,
  onEdit,
  route,
}) => {
  const projectItemMenu = useRef<HTMLDivElement>(null)
  const projectDateText = useRef<HTMLElement>(null)

  return (
    <>
      {hideActionMenu ? (
        <AppLink route={route}>
          <ListItemLink data-test={`${PROJECT_ITEM}_${index}`} onClick={onClick}>
            <ListItemName>{name}</ListItemName>
            <ListItemDateText>
              Updated: {format(parseISO(date), 'MM/dd/yyyy')}{' '}
              <HiddenLabel>{format(parseISO(date), 'HH:mm:ss')}</HiddenLabel>
            </ListItemDateText>
          </ListItemLink>
        </AppLink>
      ) : (
        <VisibleOnHoverWrapper
          dismissible={projectItemMenu}
          showIfDismissed={projectDateText}
        >
          <ProjectListItem>
            <AppLink route={route}>
              <ListItemLinkWithMenu
                data-test={`${PROJECT_ITEM}_${index}`}
                onClick={onClick}
              >
                <ListItemName>{name}</ListItemName>
                <HiddenLabel>
                  Updated: {format(parseISO(date), 'MM/dd/yyyy HH:mm:ss')}
                </HiddenLabel>
              </ListItemLinkWithMenu>
            </AppLink>
            <div ref={projectItemMenu}>
              <ProjectItemMenu
                onMove={NOOP}
                enableFolders={false}
                onEdit={onEdit}
                onDelete={onDelete}
              />
            </div>
            <ListItemDateText aria-hidden ref={projectDateText}>
              Updated: {format(parseISO(date), 'MM/dd/yyyy')}
            </ListItemDateText>
          </ProjectListItem>
        </VisibleOnHoverWrapper>
      )}
    </>
  )
}

export default BaseProjectListItem
